import TodoArrTable from "./todo_arr";

function TodoArea(props:any){
  let myProps={
    style:{},
    user:{},
    stu_info:{},
    select_date:"",
    subject_name:"",
    callback:(inData:any)=>{},
    td_sort_data_arr:[],
    on_change_todo:(inData:any)=>{},
    on_delete_todo:(inData:any)=>{},
    add_todo_arr:[],
    set_add_todo_arr:(inData:any)=>{},
    add_new_todo_row_by_ajax: (inData:any) => { },
    openTodoWriteOnePopup:(inData:any)=>{},
    ...props
  };
  let user= myProps.user;

  let get_todo_arr_tags=()=>{
    let todo_arr_tags=myProps.td_sort_data_arr.map((sort_data:any,idx:number)=>{
      return (
        <TodoArrTable
          key={idx}
          user={user}
          stu_info={myProps.stu_info}
          select_date={myProps.select_date}
          subject_name={myProps.subject_name}
          callback={myProps.callback}
          style={myProps.style}
          sort_data={sort_data}
          todo_arr={sort_data.todo_info_arr}
          on_change_todo={myProps.on_change_todo}
          on_delete_todo={myProps.on_delete_todo}
          add_todo_arr={myProps.add_todo_arr}
          set_add_todo_arr={myProps.set_add_todo_arr}
          add_new_todo_row_by_ajax={myProps.add_new_todo_row_by_ajax}
          openTodoWriteOnePopup={myProps.openTodoWriteOnePopup}
        ></TodoArrTable>
      );
    });
    if(todo_arr_tags==""){
      todo_arr_tags=(
        <div className="text-center mt-5">
          플랜이 없습니다.
        </div>
      );
    }
    return todo_arr_tags;
  };

  return (
    <div>
      {get_todo_arr_tags()}
    </div>
  );
};
export default TodoArea;